import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { TopBar } from './TopBar'
import { getVisibleNavItems } from './nav-items'
import { HeaderActionProvider } from './HeaderAction'
import { InstallPrompt } from '@/components/InstallPrompt'
import { PageLoader } from '@/components/PageLoader'
import { JobsStreamProvider } from '@/hooks/JobsStreamProvider'
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { PlayerProvider, usePlayerState } from '@/player/PlayerProvider'

// Video.js — отдельный чанк, но грузится сразу при входе (док смонтирован всегда, пустой
// без эпизода), а не по первому клику: иначе play() ушёл бы за пределы user gesture (iOS).
const PlayerDock = lazy(() =>
  import('@/player/PlayerDock').then((m) => ({ default: m.PlayerDock })),
)

export function AppLayout() {
  useKeyboardShortcuts()
  // Плеер — над key={pathname}-узлом, как и стрим задач: навигация не трогает ни
  // контроллер, ни медиа-элемент.
  return (
    <HeaderActionProvider>
      <JobsStreamProvider>
        <PlayerProvider>
          <AppFrame />
        </PlayerProvider>
      </JobsStreamProvider>
    </HeaderActionProvider>
  )
}

function AppFrame() {
  const { t } = useTranslation()
  const location = useLocation()
  const navItems = getVisibleNavItems()
  const { episode } = usePlayerState()
  return (
    <div className={`app-root${episode ? ' app-root--player' : ''}`}>
      <InstallPrompt />
      <TopBar />
      {/* key пересоздаёт DOM-узел при смене маршрута → перезапускает CSS-анимацию входа */}
      <div key={location.pathname} className="route-content">
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </div>
      <Suspense fallback={null}>
        <PlayerDock />
      </Suspense>
      <nav className="bottom-nav" aria-label={t(($) => $.nav.mobile)}>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `bottom-nav__link${isActive ? ' is-active' : ''}`}
            aria-label={t(item.label)}
            title={t(item.label)}
          >
            <span className="bottom-nav__icon" aria-hidden>
              {item.icon}
            </span>
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
